export const selectSegmentTypes = state => state.segments.segmentTypes;
export const selectSegments = state => state.segments.segments;
export const getSegmentsStatus = state => ({
  request: state.segments.segmentsRequest,
  success: state.segments.segmentsSuccess,
  failure: state.segments.segmentsFailure,
});



// WEBPACK FOOTER //
// ./src/redux/segments/selectors.js